import { BadgeDownloader } from '../../src/badge/downloader/BadgeDownloader';
import { BadgeQRCode } from '../../src/badge/qrCode/BadgeQRCode';
import { Badge } from '../../src/badge/Badge';
import { MercuryUtils } from '../../src/badge/utils/mercuryUtils';
import {
  QrCodeTypes,
  DownloadFileTypes,
  PAPER_SIZE,
  PDFEntitlementIcon,
  IMAGE,
  BADGE_DOWNLOAD_TYPE,
  IMAGE_TYPES,
  XAppNameEnum
} from '../../src/types/enums';
import { PaymentMethods, BusinessUnit } from '../../src/common/enums';
import {
  Options,
  PDFBadgeInfo,
  QrCode,
  FontOption,
  XAppName
} from '../../src/types/badge';
import { ImageConvertorResult } from '../../src/types/common';
import BadgeUtils from '../../src/badge/utils/badgeUtils';
import { RxBadgeIconPriority, RxBadgeIcon } from '../../src/types/magento';
import { Visa } from '../../src/visa/Visa';
import { VisaDocumentProps } from '../../src/visa/types';
import { VisaDocumentType } from '../../src/visa/Visa.enums';
import ReceiptBuilder, { ReceiptBuilderProps } from '../../src/receipt/builder/ReceiptBuilder';
import SVGUtils from '../../src/badge/utils/svgUtils';
import { CountriesISO2 } from '../../src/types/enums';

const getIsBadgeDoubleSided = BadgeUtils.getIsBadgeDoubleSided;
const getCountryName = BadgeUtils.getCountryName;
const getCountryList = BadgeUtils.getCountryList;
const getPortalImageDomain = BadgeUtils.getPortalImageDomain;
const getPortalImageDomainFromExistingLogoUrl =
  BadgeUtils.getPortalImageDomainFromExistingLogoUrl;
const getBadgeEntitlementIconByName = SVGUtils.getBadgeEntitlementIconByName;

export {
  ReceiptBuilder,
  BadgeDownloader,
  Badge,
  BadgeQRCode,
  MercuryUtils,
  getIsBadgeDoubleSided,
  getCountryName,
  getCountryList,
  getPortalImageDomain,
  getPortalImageDomainFromExistingLogoUrl,
  getBadgeEntitlementIconByName,
  QrCodeTypes,
  DownloadFileTypes,
  PDFEntitlementIcon,
  PAPER_SIZE,
  IMAGE_TYPES,
  IMAGE,
  BADGE_DOWNLOAD_TYPE,
  PaymentMethods,
  Visa,
  BusinessUnit,
  VisaDocumentType,
  CountriesISO2,
  XAppNameEnum
};

export type {
  PDFBadgeInfo,
  Options,
  QrCode,
  RxBadgeIconPriority,
  RxBadgeIcon,
  ImageConvertorResult,
  VisaDocumentProps,
  ReceiptBuilderProps,
  FontOption,
  XAppName
};
